





































import Vue from "vue";
export default Vue.extend({
  props: ["has_changes"],
});
